import * as ng from 'angular';

class ServiceLevelAgreementModalController implements ng.IController {

    static $inject: string[] = [
        '$scope',
        '$rootScope',
        '$state',
        'store',
        '$timeout',
        '$uibModalStack',
        '$uibModal',
        'configuration',
        '$sce'
    ];

    private close: any;

    constructor(
        private $scope: any,
        private $rootScope: any,
        private $state: ng.ui.IStateService,
        private store: ng.a0.storage.IStoreService,
        private $timeout: ng.ITimeoutService,
        private $uibModalStack: ng.ui.bootstrap.IModalStackService,
        private $uibModal: ng.ui.bootstrap.IModalService,
        private configuration: any,
        private $sce: ng.ISCEService
    ) {

        $scope.confirm = false;
        $scope.save = () => {
            this.close({ $value: $scope.confirm });
        };
        $scope.cancel = () => {
            this.close({ $value: false });
        };
    }
}

export const ServiceLevelAgreementModalComponent: ng.IComponentOptions = {
    template: require('./service-level-agreement-modal.html'),
    controller: ServiceLevelAgreementModalController,
    bindings: {
        close: '&'
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/service-level-agreement-modal/service-level-agreement-modal.ts